import React, { ChangeEvent, useState, useEffect } from "react";
import Select from "react-select";

interface DropdownNumberMandatoryProps {
  listInputs: string[];
  label: string;
  inputName: string;
  value: string[];
  isValid?: boolean;
  handleOnChange(
    e?: React.ChangeEvent<any>,
    dropDown?: {
      name: string;
      value: string[];
    }
  ): void;
  editableTitle? : JSX.Element;
}

function DropDTextMultiple({
  listInputs,
  label,
  value,
  handleOnChange,
  inputName,
  isValid = true,
  editableTitle
}: DropdownNumberMandatoryProps) {
  console.log(isValid);
  const optionsDictionary = listInputs.map((option, index) => ({
    value: option.charAt(0).toUpperCase() + option.slice(1),
    label: option.charAt(0).toUpperCase() + option.slice(1),
  }));
  var currentValues = optionsDictionary.filter((option) =>
    value.includes(option.value)
  );

  useEffect(() => {
    currentValues = optionsDictionary.filter((option) =>
      value.includes(option.value)
    );
  }, [value]);

  const throwOnChangeEvent = (
    dict: readonly {
      value: string;
      label: string;
    }[]
  ) => {
    var values = dict.map((option) => option.value);
    if (values.includes("N/A")) {
      values = ["N/A"];
    }
    handleOnChange(undefined, {
      name: inputName,
      value: values,
    });
  };
  return (
    <div className="form-group">
      {editableTitle?<label className="control-label">{editableTitle}</label>:<label className="control-label">{label}</label>}
        <div className="small-text-info">(multiple selections are possible)</div>

      <Select
        options={optionsDictionary}
        isMulti
        closeMenuOnSelect={false}
        onChange={(e) => throwOnChangeEvent(e)}
        value={currentValues}
        className={isValid ? "form-control" : "form-control is-invalid "}
      />
    </div>
  );
}
export default DropDTextMultiple;
